/**
 * @author Akshay Kumar Singh
 * @file Validator
 * @flow
 */
import SimpleReactValidator from 'simple-react-validator';
import { STRINGS, REGEX } from '../constants/data';

// Validation rules for different field name
const validator = new SimpleReactValidator({
  validators: {
    email: {  // name the rule
      message: STRINGS.CORRECTEMAIL,
      rule: (val, params, validator) => {
        return (validator.helpers.testRegex(val,
          REGEX.EMAIL)
          && params.indexOf(val) === -1)
      },
      messageReplace: (message, params) => {
        message.replace(':values', this.helpers.toSentence(params))
      },  // optional
      required: true,  // optional
    },
    password: {
      message: STRINGS.CORRECTPASSWORD,
      rule: (val, params, validator) => {
        return (val.length > 5 && val.length <= 20 && params.indexOf(val) === -1)
      },
      messageReplace: (message, params) => {
        message.replace(':values', this.helpers.toSentence(params))
      },  // optional
      required: true  // optional
    },
    auditor: {
      message: STRINGS.FIELDREQUIRED,
      rule: (val, params, validator) => {
        // return (val.length >5 && val.length <=20 && params.indexOf(val) === -1)
        return !!val.length;
      },
      required: true  // optional
    },
    reviewer: {
      message: STRINGS.FIELDREQUIRED,
      rule: (val, params, validator) => {
        return !!val;
      },
      required: true  // optional
    },
    assetsType: {
      message: STRINGS.FIELDREQUIRED,
      rule: (val, params, validator) => {
        return !!val;
      },
      required: true  // optional
    },
    lineType: {
      message: STRINGS.FIELDREQUIRED,
      rule: (val, params, validator) => {
        return !!val;
      },
      required: true  // optional
    },
    assets: {
      message: STRINGS.FIELDREQUIRED,
      rule: (val, params, validator) => {
        return !!val;
      },
      required: true  // optional
    },
    type: {
      message: STRINGS.FIELDREQUIRED,
      rule: (val, params, validator) => {
        return !!val;
      },
      required: true  // optional
    },
    frequency: {
      message: STRINGS.FIELDREQUIRED,
      rule: (val, params, validator) => {
        return !!val;
      },
      required: true  // optional
    },
    estimatedDate: {
      message: STRINGS.FIELDREQUIRED,
      rule: (val, params, validator) => {
        return !!val;
      },
      required: true  // optional
    },
    role: {
      message: STRINGS.PLEASESELECTROLE,
      rule: (val, params, validator) => {
        return !!val;
      },
      required: true  // optional
    },
    firstName: {
      message: STRINGS.FIRSTNAMEREQUIRED,
      rule: (val, params, validator) => {
        return !!val
      },
      required: true  // optional
    },
    lastName: {
      message: STRINGS.LASTNAMEREQUIRED,
      rule: (val, params, validator) => {
        return !!val
      },
      required: true  // optional
    },
    plantId: {
      message: STRINGS.PLANTREQUIRED,
      rule: (val, params, validator) => {
        return !!val
      },
      required: true  // optional
    },
    FAQFile: {
      message: STRINGS.PLEASEUPLOADPDF,
      rule: (val, params, validator) => {
        return !!val
      },
      required: true  // optional
    },
    BulkUploadFile: {
      message: STRINGS.PLEASEUPLOADEXCEL,
      rule: (val, params, validator) => {
        return !!val
      },
      required: true  // optional
    },
    armaPlantId: {
      message: STRINGS.ARMAPLANTIDREQUIRED,
      rule: (val, params, validator) => {
        return !!val.trim()
      },
      required: true  // optional
    },
    plantName: {
      message: STRINGS.PLANTNAMEREQUIRED,
      rule: (val, params, validator) => {
        return !!val.trim()
      },
      required: true  // optional
    },
    plantCode: {
      message: STRINGS.PLANTCODEREQUIRED,
      rule: (val, params, validator) => {
        return !!val.trim()
      },
      required: true  // optional
    },
    plantDirector: {
      message: STRINGS.PLANTDIRECTORREQUIRED,
      rule: (val, params, validator) => {
        return !!val.trim()
      },
      required: true  // optional
    },
    vlm: {
      message: STRINGS.PLANTTYPEREQUIRED,
      rule: (val, params, validator) => {
        return !!val.trim()
      },
      required: true  // optional
    },
    orgCode: {
      message: STRINGS.ORGCODEREQUIRED,
      rule: (val, params, validator) => {
        return !!val.trim()
      },
      required: true  // optional
    },
  }
});
export default validator;
